"use strict";

angular.module("core")
.component("imageCarousel", {
    templateUrl: require("./image-carousel.component.html"),
    controller: imageCarouselController,
    controllerAs: "imageCarouselCtrl",
    bindings: {
        images: "<",
        showDownload: "<?",
        onDownload: "<?"
    }
});

function imageCarouselController($scope) {
    var _this = this;

    $scope.options = {
        zoomEnable          : true,
        defaultIndex        : 0, // Order of the default selected Image
        images              : [],
        style               : 'inner', // inner or box
        boxW                : 400, // Box width
        boxH                : 400, // Box height
        method              : 'lens', // fallow 'lens' or 'pointer'
        cursor              : 'crosshair', // 'none', 'default', 'crosshair', 'pointer', 'move'
        lens                : true, // Lens toggle
        zoomLevel           : 4, // 0: not scales, uses the original large image size, use 1 and above to adjust.
        immersiveMode       : false,
        prevThumbButton     : '<i class="fas fa-chevron-left fa-3x" aria-hidden="true"></i>', // Prev thumb button (html)
        nextThumbButton     : '<i class="fas fa-chevron-right fa-3x" aria-hidden="true"></i>', // Next thumb button (html)
        thumbsPos           : 'top', // Thumbs position: 'top', 'bottom'
        thumbCol            : 4, // Thumb column count
        thumbColPadding     : 8 // Padding between thumbs
    };

    this.updateImages = function() {
        if (_this.images) {
            var newImages = []
            _this.images.forEach(function(image) {
                newImages.push({
                    thumb: image.image.thumbnail,
                    medium: image.image.full_size,
                    large: image.image.full_size,
                    id: image.id
                })
            })

            $scope.options.images = newImages;
        }
    }

    $scope.$watch("imageCarouselCtrl.images", function(newValue) {
        _this.updateImages();
    });

    this.updateImages();

    this.downloadImage = function() {
        this.onDownload($scope.selected);
    }
}



//////////////////
// WEBPACK FOOTER
// ./core/image-carousel/image-carousel.component.js
// module id = 628
// module chunks = 0